"use client"
import React, { Component } from 'react';
import { 
  Box, 
  Typography, 
  Paper, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Avatar,
  CircularProgress,
  Chip
} from '@mui/material';
import API, { URL_PATH } from "../../services/API";
import redux from "../../common/Redux";

class OutletsListPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: null,
      outletsData: []
    };
  }

  componentDidMount() {
    this.fetchOutletData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedHotelId?.id !== this.props.selectedHotelId?.id) {
      this.fetchOutletData();
    }
  }

  fetchOutletData = async () => {
    if (!this.props.selectedHotelId?.id) {
      this.setState({ 
        error: "Hotel ID is required",
        loading: false
      });
      return;
    }

    this.setState({ loading: true, error: null });

    try {
      const response = await API(
        this,
        "get",
        URL_PATH.getOutlets(this.props.selectedHotelId.id)
      );

      if (response.status === "success") {
        this.setState({
          outletsData: response.outletsData || [],
          loading: false
        });
      } else {
        this.setState({
          error: response.message || "Failed to fetch outlet data",
          loading: false
        });
      }
    } catch (error) {
      console.error("Error fetching outlet data:", error);
      this.setState({
        error: "An error occurred while fetching outlet data",
        loading: false
      });
    }
  };

  render() {
    const { loading, error, outletsData } = this.state;

  

    if (error) {
      return (
        <Box 
          display="flex" 
          justifyContent="center" 
          alignItems="center" 
          minHeight="200px"
          bgcolor="#02111B"
        >
          <Typography color="error">{error}</Typography>
        </Box>
      );
    }

    return (
      <Box sx={{ p: 3, bgcolor: "#02111B", minHeight: "100vh", color: "white" }}>
        <Typography variant="h4" gutterBottom sx={{ mb: 3, color: "white" }}>
          Outlets ({outletsData.length})
        </Typography>

        <TableContainer component={Paper} sx={{ bgcolor: "#07070A" }}>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: "#02111B" }}>
                <TableCell sx={{ color: "white" }}>Outlet Name</TableCell>
                <TableCell sx={{ color: "white" }}>Location</TableCell>
                <TableCell sx={{ color: "white" }}>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {outletsData.map((outlet) => (
                <TableRow 
                  key={outlet.id}
                  sx={{ 
                    '&:nth-of-type(odd)': { bgcolor: "#041A29" },
                    '&:last-child td, &:last-child th': { border: 0 }
                  }}
                >
                  <TableCell sx={{ color: "white" }}>
                    <Box display="flex" alignItems="center">
                      <Avatar
                        src={outlet.logo}
                        alt={outlet.hotel_name}
                        sx={{ width: 40, height: 40, mr: 2 }}
                      />
                      {outlet.hotel_name}
                    </Box>
                  </TableCell>
                  <TableCell sx={{ color: "white" }}>
                    {outlet.city}, {outlet.state}
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={outlet.verification_status}
                      color={outlet.verification_status === "Approved" ? "success" : "warning"}
                      size="small"
                    />
                  </TableCell>
           
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  }
}

export default redux(OutletsListPage);